import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  TextField,
} from '@mui/material';
import { createRequestExpensesCategory } from 'lib/api/requestExpenses';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { showAlert } from 'lib/functions/utils';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

type CreateRequestExpensesCategoryProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  setUp: () => Promise<void>;
};

const CreateRequestExpensesCategory = (
  props: CreateRequestExpensesCategoryProps,
) => {
  const { open, setOpen, setUp } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    hasIva: false,
  });

  const handleSave = async () => {
    if (!formData.name.trim()) {
      showAlert(dispatch, 'error', 'El nombre es requerido');
      return;
    }

    setLoading(true);
    try {
      await createRequestExpensesCategory(dispatch, formData);
      showAlert(dispatch, 'success', 'Categoría creada exitosamente');
      setOpen(false);
      resetForm();
      await setUp();
    } catch (error) {
      console.error('Error creating category:', error);
      showAlert(dispatch, 'error', 'Error al crear la categoría');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      hasIva: false,
    });
  };

  const handleCancel = () => {
    setOpen(false);
    resetForm();
  };

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Crear categoría de gastos</DialogTitle>
      <DialogContent>
        {loading ? (
          <CenteredCircularProgress type="dialog" />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <FormControl>
              <FormLabel>Nombre</FormLabel>
              <TextField
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
                fullWidth
                disabled={loading}
              />
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.hasIva}
                  onChange={(e) =>
                    setFormData({ ...formData, hasIva: e.target.checked })
                  }
                  disabled={loading}
                />
              }
              label="Tiene IVA"
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
            gap: 10,
          }}
        >
          <CustomButton
            onClick={handleCancel}
            disabled={loading}
            color="secondary"
          >
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleSave} disabled={loading}>
            {loading ? 'Creando...' : 'Crear'}
          </CustomButton>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default CreateRequestExpensesCategory;
